module.exports = __webpack_public_path__ + "static/media/filename (12).491f0ced.png";